<nova-detail-toolbar [showBackButton]="false" [template]="toolbarTemplate">
</nova-detail-toolbar>
<ng-template #toolbarTemplate>
    <div class="toolbar-buttons">
        <button *ngIf="editMode" color="primary" mat-flat-button (click)="saveChanges()" class="mr-2" [disabled]="isSaveDisabled()">SAVE CHANGES</button>
        <button color="default" mat-flat-button (click)="close()">CLOSE</button>
    </div>
</ng-template>

<div class="table-container">
    <table class="nova__table">
        <colgroup>
            <col style="width: 25%">
            <col style="width: 10%">
            <col style="width: 15%">
            <col style="width: 20%">
            <col style="width: 30%">
            <col style="width: 0%">
        </colgroup>
        <thead>
            <tr class="header-row">
                <th id="rates" class="mat-header-cell">Rates</th>
                <th id="old" class="mat-header-cell">Old</th>
                <th id="new" class="mat-header-cell">New</th>
                <th id="effectiveDate" class="mat-header-cell">Effective Date</th>
                <th id="lastChangedBy" class="mat-header-cell">Last Changed By</th>
                <th id="delete" class="mat-header-cell"></th>
            </tr>
        </thead>
        <tbody *ngIf="data?.billingPolicies?.length else emptyGrid">
            <tr class="mat-row">
                <td colspan="6">
                    <mat-expansion-panel [@.disabled]="true" [expanded]="true"
                                            class="invoice-details-expansion-panel" *ngFor="let section of rateSections">
                        <mat-expansion-panel-header class="invoice-details-expansion-panel-header">
                            {{section}}
                        </mat-expansion-panel-header>

                        <table class="nova__table">
                            <colgroup>
                                <col style="width: 50%">
                                <col style="width: 22%">
                                <col style="width: 25%">
                                <col style="width: 3%">
                            </colgroup>
                            <tr *ngFor="let item of data?.billingPolicies; index as policyIndex" [class.highlighted]="item.timeTrackingStatus === 1" class="mat-row">
                                <td class="mat-cell">
                                    {{getTimeTrackingName(item.timeTrackingStatus)}} Rate
                                    <table class="mt-1 mb-2 rate-table">
                                        <colgroup>
                                            <col style="width: 47%">
                                            <col style="width: 26%">
                                            <col style="width: 27%">
                                        </colgroup>
                                        <tr *ngFor="let rate of getRates(section, item.rates); index as rateIndex">
                                            <td>{{rate.payType}}</td>
                                            <td>{{rate.oldRate | currency:'$':'symbol':'1.0-2'}}</td>
                                            <td>$
                                                <mat-form-field appearance="outline" class="rate-input">
                                                    <input matInput type="number" [(ngModel)]="rate.newRate" [disabled]="!editMode" (change)="onRateChanged($event, policyIndex, rateIndex)">
                                                </mat-form-field>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td class="mat-cell">
                                    <mat-form-field appearance="outline" class="date-input" *ngIf="isBillSection(section)" [class.mat-form-field-invalid]="item.hasUsedDateError || item.hasOutOfRangeDateError"
                                    [ngClass]="{'height-error' : item.hasUsedDateError || item.hasOutOfRangeDateError}">
                                        <input matInput [matDatepicker]="picker" [(ngModel)]="item.startDate" (dateChange)="item.startDate = toFormattedDate($event); onDateChanged(policyIndex)" [disabled]="!editMode || item.isDateDisabled" [min]="minDate" [max]="maxDate" required>
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                    <mat-error *ngIf="item.hasUsedDateError || item.hasOutOfRangeDateError" class="error" [innerText]="item.errorMessage"></mat-error>

                                </td>
                                <td class="mat-cell updated-by">
                                    <span *ngIf="item.updatedByUserName">
                                        {{item.updatedByUserName}} ‒ <br>{{item.updatedDateUtc +'Z' | date:'MM/dd/yy hh:mmaaa'}}
                                    </span>
                                </td>
                                <td class="mat-cell">
                                    <button mat-icon-button color="primary" *ngIf="isBillSection(section) && !item.isDateDisabled && editMode" (click)="openDeleteDialog(item)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </td>
                            </tr>
                        </table>
                    </mat-expansion-panel>

                    <mat-expansion-panel [@.disabled]="true" [expanded]="true" *ngFor="let section of ruleSections"
                                            class="invoice-details-expansion-panel">
                        <mat-expansion-panel-header class="invoice-details-expansion-panel-header">
                            {{section}}
                        </mat-expansion-panel-header>

                        <table class="nova__table">
                            <colgroup>
                                <col style="width: 50%">
                                <col style="width: 22%">
                                <col style="width: 25%">
                                <col style="width: 3%">
                            </colgroup>
                            <tr *ngFor="let item of data?.billingPolicies; index as policyIndex" [class.highlighted]="item.timeTrackingStatus === 1" class="mat-row">
                                <td class="mat-cell">
                                    {{getTimeTrackingName(item.timeTrackingStatus)}} Rule
                                    <table class="mt-1 mb-2 rate-table">
                                        <colgroup>
                                            <col style="width: 47%">
                                            <col style="width: 26%">
                                            <col style="width: 27%">
                                        </colgroup>
                                        <tr *ngFor="let rule of getRates(section, item.rates); index as rateIndex">
                                            <td>{{rule.payType}}</td>
                                            <td>{{rule.oldRate}}</td>
                                            <td>
                                                <mat-form-field appearance="outline" class="rate-input">
                                                    <input matInput type="number" [(ngModel)]="rule.newRate" [disabled]="!editMode" (change)="onRateChanged($event, policyIndex, rateIndex)">
                                                </mat-form-field>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td class="mat-cell"></td>
                                <td class="mat-cell">
                                    <span *ngIf="item.updatedByUserName">
                                        {{item.updatedByUserName}} ‒ <br>{{item.updatedDateUtc +'Z' | date:'MM/dd/yy hh:mmaaa'}}
                                    </span>
                                </td>
                                <td class="mat-cell"></td>
                            </tr>
                        </table>
                    </mat-expansion-panel>
                </td>
            </tr>
        </tbody>
    </table>

    <ng-template #emptyGrid>
        <tr>
            <td colspan="6" class="empty-grid-cell">No history data</td>
        </tr>
    </ng-template>
</div>

